import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import StyledContainer from './styled'
import StyledLabel from './styled/label'
import StyledDescription from './styled/description'
import RenderIf from '../render-if'

const FormItem = ({
  style = {},
  className,
  required,
  direction,
  icon,
  label,
  description,
  error,
  children,
}) => {
  return (
    <StyledContainer
      style={style}
      className={clsx([
        {
          'flex-col': direction === 'col',
          'flex-row': direction === 'row',
          'items-center': direction === 'row',
        },
        'flex',
        className,
      ])}
    >
      <div className="flex flex-col">
        <div className="flex flex-row items-center">
          <RenderIf isTrue={required}>
            <span className="font-semibold" style={{ color: '#e85347' }}>
              *
            </span>
          </RenderIf>
          <div className="w-full flex flex-row items-center">
            <RenderIf isTrue={icon}>
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="#8c8c8c"
                className="mr-1"
                style={{ shapeRendering: 'geometricPrecision' }}
              >
                <path fillRule="evenodd" d={icon} />
              </svg>
            </RenderIf>
            <StyledLabel>{label}</StyledLabel>
          </div>
        </div>
        <RenderIf isTrue={description}>
          <StyledDescription>{description}</StyledDescription>
        </RenderIf>
      </div>
      <div>{children}</div>
      <RenderIf isTrue={error}>
        <span className="text-danger-900 mt-1" style={{ fontSize: '0.75rem' }}>
          {error}
        </span>
      </RenderIf>
    </StyledContainer>
  )
}

FormItem.propTypes = {
  // style: PropTypes.shape(PropTypes.object),
  className: PropTypes.string,
  required: PropTypes.bool,
  direction: PropTypes.string,
  icon: PropTypes.node,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  description: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  children: PropTypes.node,
}

FormItem.defaultProps = {
  // style: {},
  className: undefined,
  required: false,
  direction: 'col',
  icon: undefined,
  label: undefined,
  description: undefined,
  error: undefined,
  children: undefined,
}
export default FormItem
